// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DeliveryDateSelectionModal_delivery-slot-modal__ctqvc {
  width: 116rem;
  max-width: 100%;
  text-align: center;
}

.DeliveryDateSelectionModal_delivery-slot-modal__header__oQQko h2 {
  color: #000;
  font-size: var(--text-base);
  font-weight: 500;
  margin-bottom: 4rem;
}

.DeliveryDateSelectionModal_delivery-slot-modal__loading__EFFiW {
  margin-inline: auto;
}

.DeliveryDateSelectionModal_delivery-slot-modal__error__YLjhc {
  text-align: center;
}

.DeliveryDateSelectionModal_delivery-slot-modal__slots-container__dhuvj {
  padding: 3rem;
}

.DeliveryDateSelectionModal_delivery-slot-modal__express__erOG6 {
  padding-bottom: 2rem;
  margin-bottom: 2rem;
  border-bottom: 0.5rem solid var(--black-ten-opacity);
}

.DeliveryDateSelectionModal_delivery-slot-modal__express-fees__vnjJA {
  margin-top: 0.5rem;
  font-size: var(--text-sm);
  font-weight: 700;
  color: var(--primary-color);
}

.DeliveryDateSelectionModal_delivery-slot-modal__scheduled-header__qLodi {
  font-size: var(--text-base);
  font-weight: 500;
  margin-bottom: 2rem;
}

.DeliveryDateSelectionModal_delivery-slot-modal__scheduled-days__G-WOW {
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;
  align-items: flex-start;
}

.DeliveryDateSelectionModal_delivery-slot-modal__scheduled-day__RSu9b {
  border: 0.1rem solid var(--gray);
  border-radius: 0.8rem;
  padding: 0.6rem;
}

.DeliveryDateSelectionModal_delivery-slot-modal__scheduled-day-header__1ofZU {
  font-size: var(--text-sm);
  font-weight: 500;
  text-align: center;
}

.DeliveryDateSelectionModal_delivery-slot-modal__scheduled-day-slots__pFNP7 {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.DeliveryDateSelectionModal_delivery-slot-modal__footer__Wro23 {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.DeliveryDateSelectionModal_delivery-slot-modal__total-wrapper__VIP8Z {
  display: flex;
  align-items: center;
  gap: 0.8rem;
  color: var(--black-light);
  font-weight: 700;
}

.DeliveryDateSelectionModal_delivery-slot-modal__total-text__8PRKi {
  color: #000;
  font-size: var(--text-lg);
  font-weight: 500;
}

.DeliveryDateSelectionModal_delivery-slot-modal__total-value__FCW-T {
  display: flex;
  gap: 0.5rem;
  font-weight: 700;
  font-size: var(--text-sm);
  color: var(--black-light);
}

.DeliveryDateSelectionModal_delivery-slot-modal__fees__K6CMw {
  color: var(--primary-color);
}
`, "",{"version":3,"sources":["webpack://./src/components/UI/Modals/delivery-date-selection-modal/DeliveryDateSelectionModal.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,2BAA2B;EAC3B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,oDAAoD;AACtD;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;EAChC,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B","sourcesContent":[".delivery-slot-modal {\n  width: 116rem;\n  max-width: 100%;\n  text-align: center;\n}\n\n.delivery-slot-modal__header h2 {\n  color: #000;\n  font-size: var(--text-base);\n  font-weight: 500;\n  margin-bottom: 4rem;\n}\n\n.delivery-slot-modal__loading {\n  margin-inline: auto;\n}\n\n.delivery-slot-modal__error {\n  text-align: center;\n}\n\n.delivery-slot-modal__slots-container {\n  padding: 3rem;\n}\n\n.delivery-slot-modal__express {\n  padding-bottom: 2rem;\n  margin-bottom: 2rem;\n  border-bottom: 0.5rem solid var(--black-ten-opacity);\n}\n\n.delivery-slot-modal__express-fees {\n  margin-top: 0.5rem;\n  font-size: var(--text-sm);\n  font-weight: 700;\n  color: var(--primary-color);\n}\n\n.delivery-slot-modal__scheduled-header {\n  font-size: var(--text-base);\n  font-weight: 500;\n  margin-bottom: 2rem;\n}\n\n.delivery-slot-modal__scheduled-days {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 2rem;\n  align-items: flex-start;\n}\n\n.delivery-slot-modal__scheduled-day {\n  border: 0.1rem solid var(--gray);\n  border-radius: 0.8rem;\n  padding: 0.6rem;\n}\n\n.delivery-slot-modal__scheduled-day-header {\n  font-size: var(--text-sm);\n  font-weight: 500;\n  text-align: center;\n}\n\n.delivery-slot-modal__scheduled-day-slots {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.delivery-slot-modal__footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.delivery-slot-modal__total-wrapper {\n  display: flex;\n  align-items: center;\n  gap: 0.8rem;\n  color: var(--black-light);\n  font-weight: 700;\n}\n\n.delivery-slot-modal__total-text {\n  color: #000;\n  font-size: var(--text-lg);\n  font-weight: 500;\n}\n\n.delivery-slot-modal__total-value {\n  display: flex;\n  gap: 0.5rem;\n  font-weight: 700;\n  font-size: var(--text-sm);\n  color: var(--black-light);\n}\n\n.delivery-slot-modal__fees {\n  color: var(--primary-color);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"delivery-slot-modal": `DeliveryDateSelectionModal_delivery-slot-modal__ctqvc`,
	"delivery-slot-modal__header": `DeliveryDateSelectionModal_delivery-slot-modal__header__oQQko`,
	"delivery-slot-modal__loading": `DeliveryDateSelectionModal_delivery-slot-modal__loading__EFFiW`,
	"delivery-slot-modal__error": `DeliveryDateSelectionModal_delivery-slot-modal__error__YLjhc`,
	"delivery-slot-modal__slots-container": `DeliveryDateSelectionModal_delivery-slot-modal__slots-container__dhuvj`,
	"delivery-slot-modal__express": `DeliveryDateSelectionModal_delivery-slot-modal__express__erOG6`,
	"delivery-slot-modal__express-fees": `DeliveryDateSelectionModal_delivery-slot-modal__express-fees__vnjJA`,
	"delivery-slot-modal__scheduled-header": `DeliveryDateSelectionModal_delivery-slot-modal__scheduled-header__qLodi`,
	"delivery-slot-modal__scheduled-days": `DeliveryDateSelectionModal_delivery-slot-modal__scheduled-days__G-WOW`,
	"delivery-slot-modal__scheduled-day": `DeliveryDateSelectionModal_delivery-slot-modal__scheduled-day__RSu9b`,
	"delivery-slot-modal__scheduled-day-header": `DeliveryDateSelectionModal_delivery-slot-modal__scheduled-day-header__1ofZU`,
	"delivery-slot-modal__scheduled-day-slots": `DeliveryDateSelectionModal_delivery-slot-modal__scheduled-day-slots__pFNP7`,
	"delivery-slot-modal__footer": `DeliveryDateSelectionModal_delivery-slot-modal__footer__Wro23`,
	"delivery-slot-modal__total-wrapper": `DeliveryDateSelectionModal_delivery-slot-modal__total-wrapper__VIP8Z`,
	"delivery-slot-modal__total-text": `DeliveryDateSelectionModal_delivery-slot-modal__total-text__8PRKi`,
	"delivery-slot-modal__total-value": `DeliveryDateSelectionModal_delivery-slot-modal__total-value__FCW-T`,
	"delivery-slot-modal__fees": `DeliveryDateSelectionModal_delivery-slot-modal__fees__K6CMw`
};
export default ___CSS_LOADER_EXPORT___;
